import { render, staticRenderFns } from "./base-button-payjp.vue?vue&type=template&id=0f10b78c&"
import script from "./base-button-payjp.vue?vue&type=script&lang=js&"
export * from "./base-button-payjp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports